<div *ngIf="loading">
  <deltacapita-content-loader></deltacapita-content-loader>
</div>
<div *ngIf="!loading">
  <form [formGroup]="editIssuerContactForm" (ngSubmit)="updateIssuerContact()">
    <div class="form-group icon">
      <app-dc-input
        formControlName="name"
        type="text"
        label="Name"
        [placeholder]="contactToBeEdited.name"
      ></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-input
        formControlName="email"
        type="text"
        label="Email"
        [placeholder]="contactToBeEdited.email"
      ></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-select
        label="Role"
        [placeholder]="contactToBeEdited.role"
        [items]="rolesDropdownData"
        [checkbox]="false"
        formControlName="role"
        [disabled]="false"
        [multiple]="false"
        [searchable]="false"
        [closeOnSelect]="true"
        [readonly]="false"
      ></app-dc-select>
    </div>

    <div class="form-group icon">
      <label style="font-size: small">Sales Desk(s): </label>
      <div style="display: flex; flex-flow: row wrap">
        <div *ngFor="let salesdesk of allDesks" style="margin: 0 15px">
          <label style="font-size: small">
            <input
              type="checkbox"
              [value]="salesdesk"
              (change)="onDeskCheckboxChange($event)"
              [disabled]="isDeskDisabled"
              [checked]="currentTaggedDesks.includes(salesdesk) || isAllDeskChecked"
            />

            {{ salesdesk }}
          </label>
        </div>
      </div>
    </div>

    <div class="form-group icon">
      <label style="font-size: small">Sales Region(s): </label>
      <div style="display: flex; flex-flow: row-wrap">
        <div *ngFor="let salesregion of allRegions" style="margin: 0 15px">
          <label style="font-size: small">
            <input
              type="checkbox"
              [value]="salesregion"
              (change)="onRegionCheckboxChange($event)"
              [disabled]="isRegionDisabled"
              [checked]="currentTaggedRegions.includes(salesregion) || isAllRegionChecked"
            />

            {{ salesregion }}
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <app-dc-checkbox
        [id]="'checkbox1'"
        formControlName="optoutdocalert"
        label="Opt Out new document notification"
      ></app-dc-checkbox>
    </div>

    <br />
    <div class="m-3 d-flex align-items-center justify-content-center">
      <button class="btn btn-primary" type="submit" [disabled]="!validateForm()">Update Issuer Sales Contact</button>
    </div>
  </form>
</div>
